import { render, staticRenderFns } from "./Orderdetail.vue?vue&type=template&id=d0ef9f9a&scoped=true&"
import script from "./Orderdetail.vue?vue&type=script&lang=js&"
export * from "./Orderdetail.vue?vue&type=script&lang=js&"
import style0 from "./Orderdetail.vue?vue&type=style&index=0&id=d0ef9f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ef9f9a",
  null
  
)

export default component.exports